; (function () {
  'use strict';

  if (window.__FSN_INITED__) return;
  window.__FSN_INITED__ = true;

  // ---- Thresholds (cents) ----
  var FREE_MIN_CA = 2000 * 100;
  var VIS_MIN_CA = 1000 * 100;

  var FREE_MIN_NON_CA = 5000 * 100;
  var VIS_MIN_NON_CA = 4000 * 100;

  function fmt(cents, currency) {
    if (!isFinite(cents)) cents = 0;
    var value = cents / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return '$' + Math.round(value);
    }
  }

  function isCA() {
    var region = (document.documentElement.dataset.region || '').trim().toUpperCase();
    return region === 'CA';
  }

  // ---- Cart fetch cache + in-flight ----
  var __cartCache = { at: 0, data: { total: 0, itemCount: 0 } };
  var __inFlight = null;
  var CART_CACHE_TTL = 300;

  function invalidateCartCache() {
    __cartCache.at = 0;
    __inFlight = null;
  }

  function fetchCartState() {
    var now = Date.now();
    if (now - __cartCache.at < CART_CACHE_TTL) return Promise.resolve(__cartCache.data);
    if (__inFlight) return __inFlight;

    __inFlight = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var total = parseInt(data.total_price || 0, 10) || 0;
        var count = parseInt(data.item_count || 0, 10) || 0;
        var normalized = { total: total, itemCount: count };
        __cartCache.at = Date.now();
        __cartCache.data = normalized;
        return normalized;
      })
      .catch(function () {
        var fallback = { total: 0, itemCount: 0 };
        __cartCache.at = Date.now();
        __cartCache.data = fallback;
        return fallback;
      })
      .then(function (val) {
        __inFlight = null;
        return val;
      });

    return __inFlight;
  }

  // ---- DOM caches ----
  var __nodesCache = { at: 0, fsn: null, ship: null, shipLines: null, shipLabels: null };
  var NODES_TTL = 200;

  function getNodes(force) {
    var now = Date.now();
    if (!force && __nodesCache.fsn && now - __nodesCache.at < NODES_TTL) return __nodesCache;

    __nodesCache.at = now;
    __nodesCache.fsn = document.querySelectorAll('.js-fsn');
    __nodesCache.ship = document.querySelectorAll('.js-cart-shipping');

    // NEW: cache shipping line + label
    __nodesCache.shipLines = document.querySelectorAll('.shipping-line');
    __nodesCache.shipLabels = document.querySelectorAll('.shipping-label-element');

    return __nodesCache;
  }

  // ---- Shipping UI write ----
  var __lastShipText = null;
  var __lastShipIsFree = null;

  function resetCaches() {
    __lastShipText = null;
    __lastShipIsFree = null;
    __nodesCache.at = 0;
    __nodesCache.fsn = null;
    __nodesCache.ship = null;
    __nodesCache.shipLines = null;
    __nodesCache.shipLabels = null;
    invalidateCartCache();
  }
  window.__FSN_RESET__ = resetCaches;

  /**
   * ✅ NEW RULE:
   * - isFree=false => shipping-line tamamen gizlenir (display:none)
   * - isFree=true  => shipping-line görünür + text yazılır (FREE)
   */
  function setShippingText(text, isFree) {
    var nodes = getNodes(true);
    var shipNodes = nodes.ship;
    if (!shipNodes || !shipNodes.length) return;

    var lineNodes = nodes.shipLines || document.querySelectorAll('.shipping-line');
    var labelNodes = nodes.shipLabels || document.querySelectorAll('.shipping-label-element');

    // ✅ Free değilse: shipping-line hiç görünmesin
    if (!isFree) {
      if (__lastShipIsFree === false) return; // zaten gizliysek tekrar işleme gerek yok
      __lastShipIsFree = false;
      __lastShipText = null;

      for (var s = 0; s < lineNodes.length; s++) {
        lineNodes[s].style.display = 'none';
        lineNodes[s].classList.remove('is-centered');
      }

      for (var l = 0; l < labelNodes.length; l++) {
        labelNodes[l].style.display = 'none';
      }

      for (var i = 0; i < shipNodes.length; i++) {
        shipNodes[i].textContent = '';
        shipNodes[i].classList.remove('is-free');
      }
      return;
    }

    // ✅ Free ise: tekrar göster + FREE yaz
    if (__lastShipText === text && __lastShipIsFree === true) {
      // drawer re-render sonrası display none kalmış olabilir -> show garanti
      var anyHidden = false;
      for (var h = 0; h < lineNodes.length; h++) {
        if (lineNodes[h].style.display === 'none') { anyHidden = true; break; }
      }
      if (!anyHidden) return;
    }

    __lastShipText = text;
    __lastShipIsFree = true;

    for (var s2 = 0; s2 < lineNodes.length; s2++) {
      lineNodes[s2].style.display = '';
      lineNodes[s2].classList.remove('is-centered');
    }

    for (var l2 = 0; l2 < labelNodes.length; l2++) {
      labelNodes[l2].style.display = '';
    }

    for (var i2 = 0; i2 < shipNodes.length; i2++) {
      var el = shipNodes[i2];
      if (el.textContent !== text) el.textContent = text;
      el.classList.add('is-free');
    }
  }

  // ---- FSN container state cache ----
  var __fsnState = new WeakMap();

  function setFsnVisible(cont, visible) {
    var st = __fsnState.get(cont) || {};
    if (st.visible === visible) return;
    st.visible = visible;
    __fsnState.set(cont, st);
    cont.style.display = visible ? '' : 'none';
  }

  function setProgress(bar, cont, pctStr) {
    var st = __fsnState.get(cont) || {};
    if (st.progress === pctStr) return;
    st.progress = pctStr;
    __fsnState.set(cont, st);
    bar.style.setProperty('--progress', pctStr);
  }

  function setHeading(heading, cont, text, strong) {
    var st = __fsnState.get(cont) || {};
    var key = strong ? 'h_html' : 'h_txt';
    if (st[key] === text) return;

    st.h_html = null;
    st.h_txt = null;

    if (!strong) {
      heading.textContent = text;
      st.h_txt = text;
    } else {
      heading.innerHTML = text;
      st.h_html = text;
    }

    __fsnState.set(cont, st);
  }

  function detectCurrencyFromFsn(containers) {
    var currency = 'USD';
    if (!containers || !containers.length) return currency;
    for (var i = 0; i < containers.length; i++) {
      var blk = containers[i].querySelector('[data-fsn-root="true"]');
      if (blk && blk.dataset.currency) return blk.dataset.currency;
    }
    return currency;
  }

  // ---- AUTO FREE: tek doğru kaynak = drawer form içindeki line item data-auto-free ----
  function getAllAutoFreeFromDrawerDom(expectedCount) {
    var form = document.getElementById('cart-drawer-form');
    if (!form) return { ok: false, allAutoFree: false };

    var items = form.querySelectorAll('[data-cart-item][data-auto-free]');
    if (!items || !items.length) return { ok: false, allAutoFree: false };

    // Re-render anında kısa süre mismatch olabiliyor
    if (typeof expectedCount === 'number' && expectedCount >= 0 && items.length !== expectedCount) {
      return { ok: false, allAutoFree: false };
    }

    var all = true;
    for (var i = 0; i < items.length; i++) {
      if ((items[i].dataset.autoFree || '') !== 'true') { all = false; break; }
    }
    return { ok: true, allAutoFree: all };
  }

  // ---- Update scheduling ----
  var __scheduled = false;

  function scheduleUpdate() {
    invalidateCartCache();
    if (__scheduled) return;
    __scheduled = true;

    requestAnimationFrame(function () {
      __scheduled = false;
      updateUI();

      // DOM bazen 1 tick sonra oturuyor (remove sonrası)
      setTimeout(function () {
        invalidateCartCache();
        updateUI();
      }, 40);
    });
  }

  window.__FSN_UPDATE__ = scheduleUpdate;

  function updateUI() {
    var nodes = getNodes(true);
    var containers = nodes.fsn;
    var hasShipping = nodes.ship && nodes.ship.length;

    if ((!containers || !containers.length) && !hasShipping) return;

    fetchCartState().then(function (cart) {
      var cartTotal = cart.total;
      var itemCount = cart.itemCount;

      // Sepet boşsa -> SHIPPING satırı tamamen gizli
      if (!itemCount || cartTotal <= 0) {
        if (containers && containers.length) {
          for (var i = 0; i < containers.length; i++) setFsnVisible(containers[i], false);
        }
        setShippingText('', false);
        return;
      }

      var ca = isCA();
      var freeMin = ca ? FREE_MIN_CA : FREE_MIN_NON_CA;
      var visibleMin = ca ? VIS_MIN_CA : VIS_MIN_NON_CA;

      var currency = detectCurrencyFromFsn(containers);

      // ✅ Tag kuralı (tek doğru kaynak): line item'lardan
      var domAuto = getAllAutoFreeFromDrawerDom(itemCount);
      var allAutoFree = domAuto.ok ? domAuto.allAutoFree : false;

      // SHIPPING satırı kuralı
      var isFreeShip = allAutoFree || cartTotal >= freeMin;
      if (isFreeShip) setShippingText('FREE', true);
      else setShippingText('', false);

      // Animated FSN bar
      if (!containers || !containers.length) return;

      for (var j = 0; j < containers.length; j++) {
        var cont = containers[j];
        var block = cont.querySelector('[data-fsn-root="true"]');
        if (!block) continue;

        var heading = block.querySelector('.free-shipping-notice__heading');
        var bar = cont.querySelector('.fsn-bar');
        if (!heading || !bar) continue;

        // 🔥 stale liquid flag'i override
        block.dataset.autoFree = allAutoFree ? 'true' : 'false';

        // visible rule: visibleMin altındaysa gizle (ama allAutoFree ise her zaman göster)
        if (cartTotal < visibleMin && !allAutoFree) {
          setFsnVisible(cont, false);
          continue;
        }

        setFsnVisible(cont, true);

        if (allAutoFree) {
          setHeading(heading, cont, 'Your order is eligible for free shipping!', false);
          setProgress(bar, cont, '100%');
          continue;
        }

        if (cartTotal >= freeMin) {
          setHeading(heading, cont, 'Your order is eligible for free shipping!', false);
          setProgress(bar, cont, '100%');
          continue;
        }

        var deficit = freeMin - cartTotal;
        var deficitText = fmt(deficit, currency);

        setHeading(
          heading,
          cont,
          'Spend <strong>' + deficitText + '</strong> more for <strong>free shipping!</strong>',
          true
        );

        var pct = 0;
        if (freeMin > 0 && cartTotal > 0) pct = Math.max(0, Math.min(100, (cartTotal / freeMin) * 100));
        setProgress(bar, cont, pct + '%');
      }
    });
  }

  function onDoc(evt, handler) {
    document.addEventListener(evt, handler, { passive: true });
  }

  function init() {
    // İlk paint
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { scheduleUpdate(); }, { timeout: 1200 });
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { scheduleUpdate(); });
      });
    }

    // ✅ Ana trigger: cart drawer render bittikten sonra
    onDoc('cart:rendered', scheduleUpdate);

    // region hazır olunca
    onDoc('geo:ready', scheduleUpdate);

    // theme editor
    onDoc('shopify:section:load', function () {
      resetCaches();
      scheduleUpdate();
    });

    // quantity changes (bazı temalarda render event kaçsa bile)
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('input[name^="updates"]') || t.matches('.quantity__input')) scheduleUpdate();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

; (function fsnFallbackObserver() {
  // Fallback: cart:rendered her zaman gelmezse diye minimal observer
  if (window.__FSN_CART_OBS__) return;
  window.__FSN_CART_OBS__ = true;

  try {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;

          // sadece cart drawer içeriği geldiğinde tetikle
          if (
            (n.id === 'cart-drawer') ||
            (n.matches && n.matches('cart-drawer')) ||
            (n.querySelector && n.querySelector('cart-drawer')) ||
            (n.querySelector && n.querySelector('#cart-drawer-form [data-cart-item]'))
          ) {
            if (typeof window.__FSN_UPDATE__ === 'function') window.__FSN_UPDATE__();
            return;
          }
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    // ignore
  }
})();
